import * as React from "react";
import IReceivedDatePopupProps from "./IReceivedDatePopup";
import onClickOutside from "react-onclickoutside";

import "../../../assets/sass/widgets/datePickerWidget.scss";
import "../../../assets/sass/components/ReceivedDatePopup.scss";
import { imagePathurl } from "../../utils/utils";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const Loadable = require("react-loadable");

interface IReceivedDatePopupStateProps {
    popupVisible?: boolean;
    openCalendar: any;
    dateValue: any;
    date: any;
    todaysDate: any;
    dateErr: any;
}
const Loading = (error: any) => {
    if (error) {
        return <div>Error on loading!</div>;
    } else {
        return <div>Loading...</div>;
    }
};
const DatePickerWidget = Loadable({
    loader: () => import("../../widgets/DatePicker"),
    loading: Loading,
});
class ReceivedDatePopup extends React.Component<IReceivedDatePopupProps, IReceivedDatePopupStateProps> {
    constructor(props) {
        super(props);
        this.state = {
            popupVisible: false,
            openCalendar: false,
            dateValue: "",
            date: new Date(),
            todaysDate: new Date(),
            dateErr: {},
        };
    }

    handlePopupClose = () => {
        this.props.hidePopUp();
    };

    getDatePickerValues = (values) => {
        this.setState({ dateErr: values.error });
    };

    onConfirm = () => {
        if (!isNaN(new Date(this.state.dateValue).getTime())) {
            this.props.getReceivedDate(new Date(this.state.dateValue));
        }
    };

    dateSelection = (date) => {
        this.setState({ dateValue: date });
    };

    componentWillUnmount() {
        document.body.classList.remove("hideOverflow");
    }

    render() {
        //image CDN_PATH
        const getimagePath = imagePathurl();
        const { title, description, buttonText } = this.props;
        const { dateErr } = this.state;
        const disableMinDate = new Date();
        // const disableMaxDate = new Date();
        disableMinDate.setDate(disableMinDate.getDate() - 90);
        // disableMaxDate.setDate(disableMaxDate.getDate());
        const schema = {
            const: {
                classNames: "gaf-datepicker",
                "ui:widget": "gaf_datePicker",
                "ui:options": {
                    label: false,
                },
                fromDate: "90",
                toDate: "0",
                format: "MM/DD/YYYY",
                family: "0",
                label: description,
                description: "",
                placeholder: "MM/DD/YYYY",
                helpText: "",
            },
        };
        return (
            <React.Fragment>
                <div className="received-date-popup-container">
                    <div className="overlay" onClick={this.handlePopupClose}>
                        <div
                            className="popup-container"
                            onClick={(e) => {
                                e.stopPropagation();
                            }}>
                            <div id="close_popup" className="popup-close-icon" onClick={this.handlePopupClose}>
                                <img className="close-modal-icon" src={`${getimagePath}close-mobile.png`} alt="close" />
                            </div>
                            <div className="popup-header-title">{title}</div>
                            {/* <div className="popup-header-subtitle">{description}</div> */}

                            <DatePickerWidget
                                id="admin_datePopup"
                                errorSchema={[
                                    {
                                        key: "datePopup",
                                        parentDependency: null,
                                        isNode: false,
                                        value: [
                                            {
                                                validationType: "required",
                                                message: "Please select the warranty received date",
                                                messageForDependentNode: null,
                                                value: "",
                                            },
                                            {
                                                validationType: "futureDate",
                                                message: "Please enter a valid warranty received date",
                                                messageForDependentNode: null,
                                                value: "",
                                            },
                                        ],
                                    },
                                ]}
                                minLimit={10}
                                maxLimit={0}
                                schema={schema}
                                onChange={(event) => {
                                    return this.dateSelection(event);
                                }}
                                getValues={this.getDatePickerValues}
                            />
                            <div className="text-center">
                                <button
                                    id="delete_popup"
                                    className="popup-btn"
                                    onClick={() => this.onConfirm()}
                                    disabled={dateErr && dateErr.error}
                                >
                                    {buttonText}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default onClickOutside(ReceivedDatePopup);
